import React, { FC, useState } from 'react';
import { Popconfirm, Upload } from 'antd';

function fileSelected(
  file: any,
  updateConfirmVisibility: (boolean) => void,
  updateFileContent: (string) => void,
) {
  const reader = new FileReader();
  reader.readAsText(file);
  reader.onload = () => {
    updateFileContent(reader.result as string);
    updateConfirmVisibility(true);
  };

  // return false otherwise Upload component
  // will try to actually upload the file
  return false;
}

interface FileUploadProps {
  onChange: (s: string) => void;
  mode: string;
  accept: string;
  children: React.ReactNode;
}

const FileUpload: FC<FileUploadProps> = ({ children, onChange, accept }) => {
  const [confirmVisibility, updateConfirmVisbility] = useState(false);
  const [fileContent, updateFileContent] = useState('');

  // Partially apply arguments so that it accepts a file
  const fileSelectedPartial = (file: any): boolean => {
    return fileSelected(file, updateConfirmVisbility, updateFileContent);
  };

  const updateValue = (updating: boolean) => {
    updateConfirmVisbility(false);
    if (updating) {
      if (fileContent) {
        let value = fileContent;
        onChange(value);
      }
    }
    return false;
  };
  return (
    <>
      <Upload beforeUpload={fileSelectedPartial} fileList={[]} accept={accept}>
        {children}
      </Upload>
      <Popconfirm
        title="Are you sure you want to upload this file?"
        placement="bottomRight"
        okText="Yes"
        cancelText="No"
        open={confirmVisibility}
        onConfirm={() => updateValue(true)}
        onCancel={() => updateValue(false)}
      />
    </>
  );
};

export default FileUpload;
